import { IResponseOption, IResponseOptionGroup, ResponseOptionViewModel } from './';

export class ResponseOptionGroupViewModel {
	public responseOptionGroupId: number;
	public responseOptionGroupTypeId: number;
	public displayText: string;
	public code: string;
	public responseOptions?: ResponseOptionViewModel[];

	constructor(responseOptionGroup: IResponseOptionGroup, defaultCultureCode?: string) {
		this.responseOptionGroupId = responseOptionGroup.responseOptionGroupId;
		this.responseOptionGroupTypeId = responseOptionGroup.responseOptionGroupTypeId;

		const defaultTranslation =
			responseOptionGroup.translations && responseOptionGroup.translations.find((t) => t.cultureCode === defaultCultureCode);
		this.displayText = defaultTranslation ? defaultTranslation.text : responseOptionGroup.name;
		this.code = responseOptionGroup.code;

		if (responseOptionGroup.responseOptions) {
			this.responseOptions = responseOptionGroup.responseOptions.map(
				(ro: IResponseOption) => new ResponseOptionViewModel(ro, defaultCultureCode),
			);
		}
	}
}
